import { DEFAULT_DEADLINE_FROM_NOW } from 'constants/misc'
import { useMemo } from 'react'

import { useLatestBlock } from './useLatestBlock'

const DEADLINE_OFFSET = BigInt(DEFAULT_DEADLINE_FROM_NOW)

/**
 * combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
 * @returns {bigint | undefined} The transaction deadline as a BigInt, representing a Unix timestamp.
 */
export default function useTransactionDeadline(): bigint | undefined {
  const { blockTimestamp } = useLatestBlock()

  return useMemo(() => {
    // blockTimestamp (from useLatestBlock) should represent seconds since the Unix epoch.
    // We assume it's either a BigInt or a number safe for BigInt conversion.
    if (blockTimestamp) {
      // BigInt(blockTimestamp) ensures the timestamp is a BigInt.
      // We then add the BigInt offset to calculate the deadline.
      return BigInt(blockTimestamp) + DEADLINE_OFFSET
    }
    return undefined
  }, [blockTimestamp])
}
